import { ASBVPercentileTable } from './asbv-percentile-table';

export default ASBVPercentileTable;
